import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom"
import { useSelector } from "react-redux";
import store from "../../redux/store";
import { actualEstablishment } from "../../redux/actions/establishment";

// import Input from "../Input";
import Select from "../Select";
import search from "../../assets/icons/search.svg";
import { 
    Container, 
    EstablishmentAndInputContainer, 
    EstablishmentContainer, 
    EstablishmentText, 
    PlusButton, 
    InputContainer, 
    MessageAndUserContainer, 
    Message, 
    UserContainer, 
    UserName, 
    UserJob, 
    UserImage, 
    RedCircle
} from "./styles";
import Tooltip from "../../components/Tooltip";
import Input from "../Input";
import EstablishmentBox from "../EstablishmentBox";

//Interfaces
import { EstablishmentHeaderPropsInterface } from "./interfaces";

//Assets
import logo from "../../assets/img/logo.png";
import messageIcon from "../../assets/icons/mail.svg";
import hintHover from "../../assets/icons/hintHover.svg"
import { addressImage } from "../../service/domains";


const EstablishmentHeader = (props: EstablishmentHeaderPropsInterface) => {
    const login = useSelector((state: {login: any}) => state.login);
    const chatWithNewMessageIdList = useSelector((state: {chatWithNewMessageIdList: any}) => state.chatWithNewMessageIdList);
    const [establishmentTooltip, setEstablishmentTooltip] = useState(false)
    const { establishment } = useSelector((state: {establishment: any}) => state.establishment)
    const [searchBranchs, setSearchBranchs] = useState<Array<any>>([])
    const [ branch, setBranch ] = useState("")

    const businessNameReducerLength = (businessName: string) => {
        if(businessName.length > 27){
            return `${businessName.slice(0, 27)}...`
        } else {
            return businessName
        }
    }


    const continueAddEstablishemnt = () => {
        if(props.continueForm !== undefined && props.setContinueForm !== undefined){
            JSON.parse(localStorage.getItem("addEstablishment") as string)
            ? props.setContinueForm("0")
            : null
        }
    }

    const handleSelectChange = (data: any) => {
        const branch = props.branchsData.filter((branchData: any) => branchData.id === data.id);
        
        if(branch.length === 0){
            props.setSelectedBranch(props.branchsData[0]);
            store.dispatch(actualEstablishment(props.branchsData[0]));
            setBranch(props.branchsData[0].businessName !== null ? props.branchsData[0].businessName : props.branchsData[0].businessDescription )
        }
        
        else {
            props.setSelectedBranch(branch[0]);
            store.dispatch(actualEstablishment(branch[0]));
            setBranch(branch[0].businessName !== null ? businessNameReducerLength(branch[0].businessName) : businessNameReducerLength(branch[0].businessDescription) )
        }
    }

    return(
        <Container>
            <EstablishmentAndInputContainer>
                <EstablishmentContainer>
                    <EstablishmentText>Estabelecimento</EstablishmentText>
                    <PlusButton onClick={() => continueAddEstablishemnt()} data-toggle="modal" data-target="#addEstablishment">+</PlusButton>
                </EstablishmentContainer>
                <InputContainer>
                    <div className="inputWithIcon">
                        <Input
                            placeholder="Pesquisar estabelecimento"
                            type="search"
                            autoComplete="off"
                            isSearchField={true}
                            setValue={handleSelectChange}
                            searchType="branch"
                            searchResults={searchBranchs}
                            value={branch}
                            onChange={(e) => {
                                    let search = e.target.value.toUpperCase()
                                    let result = props.branchsData.filter(item => item.businessName?.toUpperCase().includes(search))
                                    
                                    setSearchBranchs(result.slice(0,5))
                                    setBranch(e.target.value)
                            }}
                        />
                        <img style={{top: 0}} src={search}/>
                    </div>
                </InputContainer>
            {
                window.innerWidth > 1200 
                    ? <div>
                        <img src={hintHover} style={{marginLeft: 10, width: 22}} 
                            onMouseEnter={() => {setEstablishmentTooltip(true)}}
                            onMouseLeave={() => {setEstablishmentTooltip(false)}}
                        />
                        {
                            establishmentTooltip 
                                ? <Tooltip text="" overlay={
                                    <EstablishmentBox 
                                        selectedBranch={props.selectedBranch}
                                        tooltip={true}
                                    /> }
                                /> : null
                        }
                    </div> : null
            }
            </EstablishmentAndInputContainer>

            <MessageAndUserContainer>
                <Link to="/admin/messages">
                    <div className="d-flex" style={{marginRight: 80}}>
                        <Message src={messageIcon}/>
                        { chatWithNewMessageIdList.list.length > 0 && <RedCircle/>}
                    </div>
                </Link>
                <UserContainer>
                    <div style={{marginRight: 8}}>
                        <UserName>{login.user.name}</UserName>
                        <UserJob>Administrador</UserJob>
                    </div>
                    <UserImage src={login.user.avatar !== null ? `${addressImage}${login.user.avatar}` : logo} alt="foto perfil"/>
                </UserContainer>
            </MessageAndUserContainer>
        </Container>
    )
}

export default EstablishmentHeader;